
const gemeinschaftsraeume = function() {

}

export default gemeinschaftsraeume





// WEBPACK FOOTER //
// ./scripts/barba-views/gemeinschaftsraeume.js